<template>
  <div class="app">
    <v-header/>
    <router-view/>
    <v-footer/>
  </div>
</template>

<script>
  import vHeader from './public/header'
  import vFooter from './public/footer'

  export default {
    name: "Index",
    components:{
      vHeader,vFooter
    },
    created() {
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?06cf2f54250642e6da11882435186fc4";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/index.vue